import genSaga from "../core/saga";
import types from "./types";
import actions from "./actions";
import { getAcfs } from "./services";

export default genSaga(
  types,
  {
    get: getAcfs,
  },
  actions
);
